export enum OrderValidationErrorReason {
  UnknownError = 0,
  DealerNotFound = 1,
  DealerOnCreditHold = 2,
  InvalidModelAndSerialNumber = 3,
  InvalidPONumber = 4,
  InvalidShippingAddress = 5,
  InvalidShippingCode = 6,
  ItemDiscontinued = 7,
  ItemNotAvailable = 8,
  ItemQuantityMax = 9,
  ItemQuantityStock = 10,
  ItemQuantityEmergency = 11,
  InvalidItemNumber = 12,
  ItemNotOrderable = 13,
  ItemSoftFreeze = 14,
  ItemHardFreeze = 15,
  ItemChannelAuthorization = 16,
  McfnetDown = 17,
  BulkPricingAvailable = 18,
  InvalidExxonMobilMixMatchQuantities = 19,
  InvalidSpectrumMixMatchQuantities = 20,
  InvalidStarterBatteryMixMatchQuantities = 21,
  ItemMinimumOrderQuantity = 22,
  ItemCaseQuantity = 23,
  MaterialNotListed = 24,
  SoldToCustomerBlocked = 25,
  SoldToMissing = 26,
  SoldToCustomerInvalid = 27,
  ShipToCustomerBlocked = 28,
  FinalToCustomerMissing = 29,
  MissingShipViaWarehouseCa = 30,
  InvalidShipViaWarehouseIn = 31,
  InvalidFinalTo = 32,
  NoFinalToCustomer = 33,
  ECCOPackageMixMatchTotalValue = 34,
  OfflineToSap = 35,
  PicCodeMinPriceAmount = 36,
  OfflineToWarehouseSystems = 37
}
